import * as React from 'react';
import { cn } from '@/lib/cn';

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        'flex h-10 w-full rounded-[var(--radius-input)] border border-border bg-surface px-3.5 text-sm text-ink outline-none placeholder:text-muted focus-visible:border-accent disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label ref={ref} className={cn('text-xs font-semibold uppercase tracking-wide text-muted', className)} {...props} />
  ),
);
Label.displayName = 'Label';

export function FieldError({ children }: { children?: string | null }) {
  if (!children) return null;
  return <p className="text-xs font-medium text-danger">{children}</p>;
}
